var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardsMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "credit-cards_mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21.25,
    viewBox: "0 0 30 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.25,0h27.5A1.218,1.218,0,0,1,30,1.176V18.824A1.218,1.218,0,0,1,28.75,20H1.25A1.218,1.218,0,0,1,0,18.824V1.176A1.218,1.218,0,0,1,1.25,0Z",
    fill: "#4361c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.531,0A4.531,4.531,0,1,1,0,4.531,4.535,4.535,0,0,1,4.531,0Z",
    transform: "translate(14.063 6.25)",
    fill: "#ffaf38"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 3.125,
    height: 0.625,
    transform: "translate(14.688 8.438)",
    fill: "#ffaf38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M4.531,9.063A4.531,4.531,0,1,1,9.063,4.531,4.535,4.535,0,0,1,4.531,9.063Z",
    transform: "translate(6.875 6.25)",
    fill: "#eb3636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M.312,4.375V3.75H4.375v.625ZM0,3.125V2.5H4.063v.625Zm0-1.25V1.25H4.063v.625ZM.312.625V0H4.375V.625Z",
    transform: "translate(14.375 8.438)",
    fill: "#ffaf38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M1.25,21.25h.563L30,1.813V1.25A1.254,1.254,0,0,0,28.75,0H1.25A1.254,1.254,0,0,0,0,1.25V20A1.254,1.254,0,0,0,1.25,21.25Z",
    fill: "#fff",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardsMastercard);
export default __webpack_public_path__ + "static/media/credit-cards_mastercard.dcf581de0f96c64cf14d8a417bde05c6.svg";
export { ForwardRef as ReactComponent };